import * as yup from "yup";

export const jobTypeEmployeeTypeSchema = yup.object().shape({
  employeeTypeIds: yup.array().of(yup.string()),
});
